import firebase from "../firebase";
import axios from "axios";
import {
  ACCOUNT_RECOVER,
  ACCOUNT_RECOVER_FAIL,
  ACTION_REQUEST,
  ACTION_REQUEST_END,
  ADDRESS_UPDATE_FAIL,
  ADDRESS_UPDATE_SUCCESS,
  AUTH_RESET,
  EMAIL_UPDATE_FAIL,
  EMAIL_UPDATE_SUCCESS,
  GET_PACKAGES,
  GOOGLE_FULL_SIGNUP_FAIL,
  GOOGLE_FULL_SIGNUP_SUCCESS,
  GOOGLE_LOGIN_SUCCESS,
  GOOGLE_SIGNUP_FAIL,
  GOOGLE_SIGNUP_SUCCESS,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
  NAME_UPDATE_FAIL,
  NAME_UPDATE_SUCCESS,
  PHONE_LOGIN,
  PHONE_SIGNUP_FAIL,
  PHONE_UPDATE_FAIL,
  PHONE_UPDATE_SUCCESS,
  PHONE_VERIFIED,
  PHONE_VERIFIED_END,
  REGISTER_COMPLETE,
  REGISTER_FAIL,
  REGISTER_SUCCESS,
  SET_DELIVERY_LOADING,
  UPDATE_USER,
} from "./types";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { customAlert } from "./alertActions";
import { BASE_DOMAIN } from "../../constants/index";

let signInCheck = false;

export const getUser =
  (uid, router = null) =>
  async (dispatch) => {
    var tempUser = {};
    let obj = [];
    obj.push(
      new Promise((resolve, reject) => {
        firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .onSnapshot((doc) => {
            if (doc.exists) {
              if (doc.data().blocked) {
                dispatch(
                  customAlert(true, "You are not allowed to access this panel")
                );
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                // alert('You are not allowed to access this panel');
                dispatch({
                  type: ACTION_REQUEST_END,
                });
              } else {
                tempUser = { id: doc.id, ...doc.data() };
                if (doc.data().firstSignIn) {
                  signInCheck = true;
                }

                dispatch({
                  type: LOGIN_SUCCESS,
                  user: tempUser,
                  error: "",
                });
                dispatch({
                  type: ACTION_REQUEST_END,
                });

                resolve(tempUser);
              }
            }
          });
      })
    );

    Promise.all(obj).then(() => {
      if (router != null && tempUser) {
        // if (
        // 	firebase.auth().currentUser.metadata.creationTime ===
        // 	firebase.auth().currentUser.metadata.lastSignInTime
        // ) {
        // 	await dispatch({ type: 'FIRST_SIGN_IN', payload: true });
        // 	router.push('/dashboard/memoirs');
        // }
        if (tempUser && tempUser.firstSignIn) {
          router.push("/dashboard/memoirs");
        } else {
          router.push("/dashboard/manage-account");
        }
      }
    });
  };

export const updateFirstSignIn = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .doc(id)
    .update({ firstSignIn: false });
};

export const resetSignIn = () => async (dispatch) => {
  await dispatch({ type: "RESET_SIGN_IN", payload: false });
};
export const login = (credentials, history) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    firebase
      .auth()
      .signInWithEmailAndPassword(credentials.email, credentials.password)
      .then(async (data) => {
        await dispatch(getUser(data.user.uid, history));

        // if (signInCheck) {
        // 	history.push('/dashboard/memoirs');
        // } else {
        // 	history.push('/dashboard/manage-account');
        // }
      })
      .catch((error) => {
        dispatch({
          type: LOGIN_FAIL,
          uid: "",
          error: error,
        });
        dispatch({
          type: ACTION_REQUEST_END,
        });
        dispatch(customAlert(true, error.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // alert(error, 'danger');
      });
  };
};
export const updateUserInfo = (uid, obj) => async (dispatch) => {
  dispatch({
    type: SET_DELIVERY_LOADING,
    payload: true,
  });
  firebase
    .firestore()
    .collection("users")
    .doc(uid)
    .update(obj)
    .then((res) => {
      dispatch(getUser(uid));
    });
  dispatch({
    type: SET_DELIVERY_LOADING,
    payload: false,
  });
};

export const logout = () => {
  return (dispatch) => {
    firebase
      .auth()
      .signOut()
      .then((data) => {
        dispatch({
          type: LOGOUT_SUCCESS,
          uid: "",
          error: "",
        });
      })
      .catch((error) => {
        dispatch({
          type: LOGOUT_FAIL,
          uid: "",
          error: error,
        });
      });
  };
};

export const removeAuthError = () => {
  return (dispatch) => {
    dispatch({
      type: AUTH_RESET,
      uid: "",
      error: "",
    });
  };
};
export const registeredComplete = () => {
  return (dispatch) => {
    dispatch({
      type: REGISTER_COMPLETE,
    });
  };
};

export const register = (
  credentials,
  password,
  token,
  _history,
  amount,
  onSuccess = () => {}
) => {
  // console.log('creds', credentials);
  // console.log('token', token)
  // console.log('amount', amount);
  return async (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    axios
      .post(`${BASE_DOMAIN}/createCustomer`, {
        token,
        email: credentials.email,
      })
      .then((res) => {
        var customer_id = res.data.data.id;

        if (credentials.price) {
          axios
            .post(`${BASE_DOMAIN}/createSubscription`, {
              customer_id,
              price_id: credentials.price,
            })
            .then((res) => {
              var subscription_id = res.data.data.id;
              if (credentials.uid) {
                let credUid = credentials.uid;
                delete credentials["uid"];
                firebase
                  .firestore()
                  .collection("users")
                  .doc(credUid)
                  .set({
                    ...credentials,
                    customer_id,
                    subscription_id,
                    firstSignIn: true,
                  })
                  .then((res) => {
                    firebase
                      .firestore()
                      .collection("plan_earnings")
                      .add({
                        user_id: credUid,
                        created_at: firebase.firestore.Timestamp.now(),
                        total: Number(amount / 100),
                        plan_name: credentials.plan_name,
                      });
                    dispatch({
                      type: REGISTER_SUCCESS,
                    });
                    dispatch({
                      type: ACTION_REQUEST_END,
                    });
                    onSuccess();
                    dispatch(customAlert(true, "Account Created Successfully"));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 3000);
                    // alert('Account Created Successfully');
                    _history.push("/dashboard/register");
                  })
                  .catch((err) => {
                    dispatch({
                      type: REGISTER_FAIL,
                    });
                    dispatch({
                      type: ACTION_REQUEST_END,
                    });
                    dispatch(customAlert(true, err.message));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 3000);
                    // alert(err, 'danger');
                  });
              } else {
                firebase
                  .auth()
                  .createUserWithEmailAndPassword(credentials.email, password)
                  .then((data) => {
                    firebase
                      .firestore()
                      .collection("users")
                      .doc(data.user.uid)
                      .set({
                        ...credentials,
                        customer_id,
                        subscription_id,
                        firstSignIn: true,
                        type: "email",
                      })
                      .then((res) => {
                        firebase
                          .firestore()
                          .collection("plan_earnings")
                          .add({
                            user_id: data.user.uid,
                            created_at: firebase.firestore.Timestamp.now(),
                            total: Number(amount / 100),
                            plan_name: credentials.plan_name,
                          });
                        dispatch({
                          type: REGISTER_SUCCESS,
                        });
                        dispatch({
                          type: ACTION_REQUEST_END,
                        });
                        // alert(
                        // 	'Account Created Successfully'
                        // );
                        onSuccess();
                        dispatch(
                          customAlert(true, "Account Created Successfully")
                        );
                        setTimeout(() => {
                          dispatch(customAlert(false, ""));
                        }, 3000);
                        _history.push("/dashboard/register");
                      })
                      .catch((err) => {
                        dispatch({
                          type: REGISTER_FAIL,
                        });
                        dispatch({
                          type: ACTION_REQUEST_END,
                        });
                        dispatch(customAlert(true, err));
                        setTimeout(() => {
                          dispatch(customAlert(false, ""));
                        }, 3000);
                        // alert(err, 'danger');
                        console.log(err);
                      });
                  })
                  .catch((err) => {
                    dispatch({
                      type: REGISTER_FAIL,
                    });
                    dispatch({
                      type: ACTION_REQUEST_END,
                    });
                    dispatch(customAlert(true, err.message));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 3000);
                    // alert(err, 'danger');
                    console.log(err);
                  });
              }
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err);
              dispatch({
                type: REGISTER_FAIL,
              });
              dispatch({
                type: ACTION_REQUEST_END,
              });
            });
        } else {
          if (credentials.uid) {
            let credUid = credentials.uid;
            delete credentials["uid"];
            firebase
              .firestore()
              .collection("users")
              .doc(credUid)
              .set({
                ...credentials,
                customer_id,
                firstSignIn: true,
              })
              .then((res) => {
                firebase
                  .firestore()
                  .collection("plan_earnings")
                  .add({
                    user_id: credUid,
                    created_at: firebase.firestore.Timestamp.now(),
                    total: Number(amount / 100),
                    plan_name: credentials.plan_name,
                  });
                dispatch({
                  type: REGISTER_SUCCESS,
                });
                dispatch({
                  type: ACTION_REQUEST_END,
                });
                // alert('Account Created Successfully');
                onSuccess();
                dispatch(customAlert(true, "Account Created Successfully"));
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                _history.push("/dashboard/register");
              })
              .catch((err) => {
                dispatch({
                  type: REGISTER_FAIL,
                });
                dispatch({
                  type: ACTION_REQUEST_END,
                });
                dispatch(customAlert(true, err));
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                // alert(err, 'danger');
                console.log(err);
              });
          } else {
            firebase
              .auth()
              .createUserWithEmailAndPassword(credentials.email, password)
              .then((data) => {
                firebase
                  .firestore()
                  .collection("users")
                  .doc(data.user.uid)
                  .set({
                    ...credentials,
                    customer_id,
                    firstSignIn: true,
                  })
                  .then((res) => {
                    firebase
                      .firestore()
                      .collection("plan_earnings")
                      .add({
                        user_id: data.user.uid,
                        created_at: firebase.firestore.Timestamp.now(),
                        total: Number(amount / 100),
                        plan_name: credentials.plan_name,
                      });
                    dispatch({
                      type: REGISTER_SUCCESS,
                    });
                    dispatch({
                      type: ACTION_REQUEST_END,
                    });
                    onSuccess();
                    dispatch(customAlert(true, "Account Created Successfully"));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 3000);
                    // alert('Account Created Successfully');
                    _history.push("/dashboard/register");
                  })
                  .catch((err) => {
                    dispatch({
                      type: REGISTER_FAIL,
                    });
                    dispatch({
                      type: ACTION_REQUEST_END,
                    });
                    dispatch(customAlert(true, err.message));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 3000);
                    // alert(err, 'danger');
                  });
              })
              .catch((err) => {
                dispatch({
                  type: REGISTER_FAIL,
                });
                dispatch({
                  type: ACTION_REQUEST_END,
                });
                dispatch(customAlert(true, err.message));
                setTimeout(() => {
                  dispatch(customAlert(false, ""));
                }, 3000);
                // alert(err, 'danger');
                console.log(err);
              });
          }
        }
      })
      .catch((err) => {
        // alert(err);
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        dispatch({
          type: REGISTER_FAIL,
        });
        dispatch({
          type: ACTION_REQUEST_END,
        });
      });
  };
};

export const registerFree = (
  credentials,
  password,
  _history,
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    if (credentials.uid) {
      let credUid = credentials.uid;
      delete credentials["uid"];
      await firebase
        .firestore()
        .collection("users")
        .doc(credUid)
        .set({
          ...credentials,
          firstSignIn: true,
        })
        .then((res) => {
          dispatch({
            type: REGISTER_SUCCESS,
          });
          dispatch({
            type: ACTION_REQUEST_END,
          });
          onSuccess();
          dispatch(customAlert(true, "Account Created Successfully"));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // alert('Account Created Successfully');
          _history.push("/dashboard/register");
        })
        .catch((err) => {
          dispatch({
            type: REGISTER_FAIL,
          });
          dispatch({
            type: ACTION_REQUEST_END,
          });
          dispatch(customAlert(true, err.message));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // alert(err, 'danger');
        });
    } else {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(credentials.email, password)
        .then(async (data) => {
          await firebase
            .firestore()
            .collection("users")
            .doc(data.user.uid)
            .set({
              ...credentials,
              type: "email",
              firstSignIn: true,
            })
            .then((res) => {
              dispatch({
                type: REGISTER_SUCCESS,
              });
              dispatch({
                type: ACTION_REQUEST_END,
              });
              onSuccess();
              dispatch(customAlert(true, "Account Created Successfully"));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert('Account Created Successfully');
              _history.push("/dashboard/register");
            })
            .catch((err) => {
              dispatch({
                type: REGISTER_FAIL,
              });
              dispatch({
                type: ACTION_REQUEST_END,
              });
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err, 'danger');
            });
        })
        .catch((err) => {
          dispatch({
            type: REGISTER_FAIL,
          });
          dispatch({
            type: ACTION_REQUEST_END,
          });
          dispatch(customAlert(true, err.message));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // alert(err, 'danger');
        });
    }
  };
};

export const signupGoogle = (_history) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    var provider = new firebase.auth.GoogleAuthProvider();
    const firestore = firebase.firestore();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async (result) => {
        console.log(result.user);
        var FreshUser = await firestore
          .collection("users")
          .doc(result.user.uid)
          .get();
        if (!FreshUser.exists) {
          _history.push("/dashboard/signup");
          dispatch({
            type: GOOGLE_SIGNUP_SUCCESS,
            user: {
              id: result.user.uid,
              email: result.user.email,
              phone: result.user.phone ? result.user.phone : "",
              first_name: result.user.displayName.split(" ")[0],
              last_name: result.user.displayName.split(" ")[1]
                ? result.user.displayName.split(" ")[1]
                : "",
              profile_image: result.user.photoURL ? result.user.photoURL : "",
              type: "google",
              firstSignIn: true,
            },
          });
          dispatch({
            type: ACTION_REQUEST_END,
          });
        } else {
          dispatch(getUser(FreshUser.id, _history));
          // dispatch({
          // 	type: GOOGLE_LOGIN_SUCCESS,
          // 	user: { id: FreshUser.id, ...FreshUser.data() },
          // 	error: '',
          // });
          dispatch({
            type: ACTION_REQUEST_END,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: GOOGLE_SIGNUP_FAIL,
          uid: "",
          error: error,
        });
        dispatch({
          type: ACTION_REQUEST_END,
        });
        dispatch(customAlert(true, error.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // alert(error, 'danger');
      });
  };
};

export const passwordLoader = (val) => async (dispatch) => {
  dispatch({
    type: "RESET_PASSWORD_LOADER",
    payload: val,
  });
};

export const resetPassword = (email, url) => async (dispatch) => {
  dispatch(passwordLoader(true));
  const response = await firebase
    .firestore()
    .collection("users")
    .where("email", "==", email)
    .get();
  if (response.docs[0]) {
    firebase
      .auth()
      .sendPasswordResetEmail(email, { url: url, handleCodeInApp: false })
      .then(() => {
        dispatch(
          customAlert(true, `Reset Password link sent to your ${email}.`)
        );
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // alert(`Reset Password link sent to your ${email}.`);
      });
    dispatch(passwordLoader(false));
  } else {
    dispatch(customAlert(true, "No user found with this Email"));
    setTimeout(() => {
      dispatch(customAlert(false, ""));
    }, 3000);
    // alert('No user found with this Email');
    dispatch(passwordLoader(false));
  }
};

export const googleFullSignup = (user, token) => {
  console.log({ user });
  return (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    axios
      .post(`${BASE_DOMAIN}/createCustomer`, {
        token,
        email: user.email,
      })
      .then((res) => {
        var customer_id = res.data.data.id;
        if (user.price) {
          axios
            .post(`${BASE_DOMAIN}/createSubscription`, {
              customer_id,
              price_id: user.price,
            })
            .then((res) => {
              var subscription_id = res.data.data.id;
              firebase
                .firestore()
                .collection("users")
                .doc(user.id)
                .set({
                  ...user,
                  customer_id,
                  subscription_id,
                  firstSignIn: true,
                })
                .then((res) => {
                  dispatch({
                    type: GOOGLE_FULL_SIGNUP_SUCCESS,
                  });
                  dispatch({
                    type: ACTION_REQUEST_END,
                  });
                  dispatch(customAlert(true, "Account Created Successfully"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 3000);
                  // alert('Account Created Successfully');
                })
                .catch((err) => {
                  dispatch({
                    type: GOOGLE_FULL_SIGNUP_FAIL,
                  });
                  dispatch({
                    type: ACTION_REQUEST_END,
                  });
                });
            })
            .catch((err) => {
              dispatch(customAlert(true, err.message));
              setTimeout(() => {
                dispatch(customAlert(false, ""));
              }, 3000);
              // alert(err);
            });
        }
      });
  };
};

export const signupFacebook = () => {
  return (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    var provider = new firebase.auth.FacebookAuthProvider();
    const firestore = firebase.firestore();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async (result) => {
        console.log(result.user);
        var FreshUser = await firestore
          .collection("users")
          .doc(result.user.uid)
          .get();
        if (!FreshUser.exists) {
          return firestore
            .collection("users")
            .doc(result.user.uid)
            .set({
              name: result.user.displayName,
              email: result.user.email,
              firstSignIn: true,
            })
            .then((res) => {
              const config = {
                headers: {
                  "Content-Type": " application/json",
                  "Access-Control-Allow-Origin": "*",
                },
              };
              const body = {
                email: result.user.email,
              };

              axios.post(
                "https://us-central1-coin-hunter-admin.cloudfunctions.net/Notify",
                body,
                config
              );

              dispatch({
                type: GOOGLE_SIGNUP_SUCCESS,
                user: { id: FreshUser.id, ...FreshUser.data() },
                error: "",
              });
              dispatch({
                type: ACTION_REQUEST_END,
              });
            })
            .catch((error) => {
              dispatch({
                type: GOOGLE_SIGNUP_FAIL,
                uid: "",
                error: error,
              });
              dispatch({
                type: ACTION_REQUEST_END,
              });
            });
        } else {
          dispatch({
            type: GOOGLE_SIGNUP_SUCCESS,
            user: { id: FreshUser.id, ...FreshUser.data() },
            error: "",
          });
          dispatch({
            type: ACTION_REQUEST_END,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: GOOGLE_SIGNUP_FAIL,
          uid: "",
          error: error,
        });
        dispatch({
          type: ACTION_REQUEST_END,
        });
      });
  };
};

export const recoverAccount = (email) => {
  return (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then((res) => {
        dispatch({
          type: ACTION_REQUEST_END,
        });
        dispatch({
          type: ACCOUNT_RECOVER,
        });
        dispatch(customAlert(true, "Email Sent for Account Recovery"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // alert('Email Sent for Account Recovery');
      })
      .catch((err) => {
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // console.log(err);
        dispatch({
          type: ACCOUNT_RECOVER_FAIL,
        });
      });
  };
};
export const updateUser = (uid, user, currentPassword, onSuccess) => {
  console.log(user, "myuser");
  let password = user["new_password"];
  delete user["updatePassword"];
  delete user["new_password"];
  delete user["repeat_password"];
  return async (dispatch) => {
    // let data = {
    //   ...user,
    //   delivery_address: {
    //     address1: user.address1,
    //     address2: user.address2,
    //     city: user.city,
    //     country: user.country,
    //     first_name: user.firstname,
    //     last_name: user.lastname,
    //     zip_code: user.zip_code,
    //   },
    // };
    await firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update(user)
      .then((res) => {
        if(currentPassword!="text"){
          onSuccess();
          dispatch(customAlert(true, "Personal Information Updated"));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          return;
        }else{
        
        }
       
      });
    let users = firebase.auth().currentUser;

    if (users != null) {
      if (currentPassword.current_password) {
        let creds = firebase.auth.EmailAuthProvider.credential(
          users.email,
          currentPassword.current_password
        );
        delete currentPassword["current_password"];
        users
          .reauthenticateWithCredential(creds)
          .then(() => {
            users.updatePassword(password);
            dispatch({
              type: UPDATE_USER,
            });
            dispatch(customAlert(true, "User Profile is updated!"));
            setTimeout(() => {
              dispatch(customAlert(false, ""));
            }, 3000);
            // alert('User Profile is updated!');
          })
          .catch((error) => {
            error = true;
            dispatch(customAlert(true, "current password did not matched"));
            setTimeout(() => {
              dispatch(customAlert(false, ""));
            }, 3000);
          });
      }
    }
  };
};
export const imageLoading = (val) => async (dispatch) => {
  dispatch({
    type: "IMAGE_LOADING",
    payload: val,
  });
};
export const updateProfileImage =
  (uid, newFile, prevFile, onSuccess = () => {}) =>
  async (dispatch) => {
    // console.log('uid', uid, 'file', file, 'prevFile', prevFile);
    dispatch(imageLoading(true));
    if (prevFile) {
      await firebase.storage().refFromURL(prevFile).delete();
    }
    var storageRef = await firebase
      .storage()
      .ref()
      .child(
        newFile?.file?.type?.split("/").pop() === "jpeg"
          ? "profile_images/" + uuidv4() + ".jpg"
          : "profile_images/" +
              uuidv4() +
              "." +
              newFile?.file?.type?.split("/").pop()
      )
      .put(newFile?.file, {
        contentType: newFile?.file?.type,
      });
    let url = await storageRef.ref.getDownloadURL();
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({
        profile_image: url,
      })
      .then((res) => {
        onSuccess();
        dispatch(customAlert(true, "Profile Image Updated Successfully"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.success('Profile Image Updated Successfully');
        dispatch(getUser(uid));
        dispatch(imageLoading(false));
        return;
      });
  };
export const updatePlanEarnings = (uid, obj) => async (dispatch) => {
  let response = await firebase
    .firestore()
    .collection("plan_earnings")
    .where("user_id", "==", uid)
    .get();
  if (response.docs[0]) {
    await firebase
      .firestore()
      .collection("plan_earnings")
      .doc(response.docs[0].id)
      .update({
        plan_name: obj.plan_name,
        total: obj.plan_amount,
      });
  } else {
    await firebase.firestore().collection("plan_earnings").add({
      plan_name: obj.plan_name,
      total: obj.plan_amount,
      created_at: firebase.firestore.Timestamp.now(),
      user_id: uid,
    });
  }
};
export const setDeliveryLoading = (val) => async (dispatch) => {
  dispatch({
    type: SET_DELIVERY_LOADING,
    payload: val,
  });
};
export const updateDeliveryAddress =
  (uid, delivery_address) => async (dispatch) => {
    dispatch(setDeliveryLoading(true));
    firebase
      .firestore()
      .collection("users")
      .doc(uid)
      .update({ delivery_address })
      .then((res) => {
        dispatch(customAlert(true, "Delivery Address Saved Successfully"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.success('Delivery Address Saved Successfully');
        dispatch(setDeliveryLoading(false));
      })
      .catch((err) => {
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.warning(err.message);
        dispatch(setDeliveryLoading(false));
      });
  };
export const phoneLogin = (user) => {
  return async (dispatch) => {
    dispatch({
      type: ACTION_REQUEST,
    });
    dispatch({
      type: PHONE_VERIFIED,
      phone: user.user.phoneNumber,
    });
    dispatch({
      type: ACTION_REQUEST_END,
    });
  };
};
export const removeVerified = () => {
  return async (dispatch) => {
    dispatch({
      type: PHONE_VERIFIED_END,
    });
  };
};

export const getPackages = () => {
  return async (dispatch) => {
    axios.get(`${BASE_DOMAIN}/getPackages`).then((res) => {
      console.log(res.data.data);
      let { products, prices } = res.data.data;
      dispatch({
        type: GET_PACKAGES,
        products,
        prices,
      });
    });
  };
};
export const getCardDetails =
  (id, onSuccess = (res) => {}) =>
  async (dispatch) => {
    await firebase
      .firestore()
      .collection("users")
      .doc(id)
      .onSnapshot((data) => {
        axios
          .post(`${BASE_DOMAIN}/fetchCard`, {
            customer_id: data.data()?.customer_id,
          })
          .then((res) => {
            onSuccess(res.data.data.last4);
            dispatch({
              type: "GET_CARD_DETAILS",
              payload: res.data.data,
            });
          });
      });
  };
